module.exports = __webpack_public_path__ + "static/media/about-header.21242adf.jpg";